export enum enumDLIDocumentationGroups {
  'RSAID' = 1,
  'Passport',
  'Asylum Seeker',
  'Refugee',
  'Company',
  'Trust',
  'Close Corporation',
  'Partnership',
  'Sole Proprieter'
}

export namespace enumDLIDocumentationGroups {
  export function values() {
    return Object.keys(enumDLIDocumentationGroups).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
